<form [formGroup]="secondQuestionFormGroup" class="wizard-item">
    <div class="row">
        <div class="col-12 wizard-question">
            {{'contractModifications.wizard.questions.WhatIsTheSourceOfThePayment' | translate}}
        </div>
    </div>
    <ng-container *ngFor="let paymentSource of paymentSourcesDatasource; let indexPaymentSource = index">
        <div class="row justify-content-center">
            <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4 radio-container">
                <input class="radio-input" type="radio" kendoRadioButton size="large"
                    id="paymentSource-{{indexPaymentSource}}"
                    name="answear"
                    [value]="paymentSource.id"
                    [(ngModel)]="secondQuestionFormGroup.value.answear"
                    formControlName="answear"
                    required
                >
                <label class="radio-label" for="paymentSource-{{indexPaymentSource}}">
                    {{paymentSource.value}}
                </label>
            </div>
        </div>
    </ng-container>


    <div class="row justify-content-center l-uploader-container">
        <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4">
            <contract-modification-uploader
                [contractModificationRequest]="contractModificationRequest"

                [deleteFileHandler]="deleteFileHandler"
                [uploadFilesHandler]="uploadFilesHandler"
            >
            </contract-modification-uploader>
        </div>
    </div>

    <div class="d-flex justify-content-center l-next-step-container">
            <button
                class="btn primary-btn"
                [disabled]="secondQuestionFormGroup.value.answear === null"
                (click)="nextStepHandler(wizardStepsEnum.ContractModification_PaymentSource)"
            >
                {{'contractModifications.wizard.continueBtn' | translate}}
            </button>
    </div>
</form>
